
import { mixins } from "vue-class-component";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class JbActiveChip extends Vue {
  @Prop(Boolean) readonly active!: boolean;
  @Prop({ default: "Active" }) readonly activeText!: string;
  @Prop({ default: "Inactive" }) readonly inactiveText!: string;
}
